angular
  .module('contrast.services.blockingmodal', ['ui.bootstrap'])
  .factory('BlockingPerimeterModalService', function ($uibModal) {
    return {
      openModal: function (promiseConfigs, callback, logging) {
        $uibModal
          .open({
            templateUrl:
              'views/applications/settings/block_at_perimeter_modal.html',
            controller: 'ModalBlockAtPerimeterModalCtrl',
            size: 'md',
            resolve: {
              promiseConfigs: function () {
                return promiseConfigs
              },
              callback: function () {
                return callback
              },
              withLogging: function () {
                return logging
              }
            }
          })
          .result.finally(function () {
            if (angular.isFunction(callback)) {
              callback()
            }
          })
      }
    }
  })
